export interface Plan {
  name: string;
  monthlyPrice: number;
  yearlyPrice: number;
  originalYearlyPrice: number;
  description: string;
  features: string[];
  isPopular?: boolean;
}

export const plans: Plan[] = [
  {
    name: "Essential",
    monthlyPrice: 4.99,
    yearlyPrice: 49.9,
    originalYearlyPrice: 59.88,
    description: "Perfect for moderate usage, offering substantial daily access to video chats.",
    features: [
      "30 videos per day",
      "30 messages per video",
      "Process videos without transcripts (up to 45 minutes each)",
      "Priority email support",
      "Priority access to new features"
    ]
  },
  {
    name: "Growth",
    monthlyPrice: 9.99,
    yearlyPrice: 99.9,
    originalYearlyPrice: 119.88,
    description: "Unlock greater possibilities with expanded video chats and messaging capabilities.",
    features: [
      "100 videos per day",
      "100 messages per video",
      "Process videos without transcripts (up to 2 hours each)",
      "Priority email support",
      "Priority access to new features"
    ],
    isPopular: true
  },
  {
    name: "Pro",
    monthlyPrice: 14.99,
    yearlyPrice: 149.9,
    originalYearlyPrice: 179.88,
    description: "Open the door to infinite interactions with all-day, every-video chat access.",
    features: [
      "Unlimited videos per day",
      "Unlimited messages per video",
      "Process videos without transcripts (up to 3 hours each)",
      "Priority email support",
      "Priority access to new features"
    ]
  }
];